import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Textarea } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Copy, Check } from 'lucide-react';
export function JsonFormatter() {
  const [inputJson, setInputJson] = useState('');
  const [outputJson, setOutputJson] = useState('');
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const formatJson = () => {
    try {
      const parsed = JSON.parse(inputJson);
      const formatted = JSON.stringify(parsed, null, 2);
      setOutputJson(formatted);
      setError('');
    } catch (e) {
      setError('Invalid JSON: ' + (e as Error).message);
      setOutputJson('');
    }
  };
  const minifyJson = () => {
    try {
      const parsed = JSON.parse(inputJson);
      const minified = JSON.stringify(parsed);
      setOutputJson(minified);
      setError('');
    } catch (e) {
      setError('Invalid JSON: ' + (e as Error).message);
      setOutputJson('');
    }
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(outputJson);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="container mx-auto px-4 py-8 max-w-6xl" data-id="element-139">
      <div className="mb-8" data-id="element-140">
        <h1 className="text-4xl font-bold mb-2" data-id="element-141">JSON Formatter</h1>
        <p className="text-muted-foreground" data-id="element-142">
          Format, validate, and minify JSON data
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-143">
        <Card data-id="element-144">
          <CardHeader data-id="element-145">
            <CardTitle data-id="element-146">Input JSON</CardTitle>
            <CardDescription data-id="element-147">Paste your JSON here</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4" data-id="element-148">
            <Textarea value={inputJson} onChange={e => setInputJson(e.target.value)} placeholder='{"name": "John", "age": 30}' rows={15} className="font-mono text-sm" data-id="element-149" />
            <div className="flex gap-2" data-id="element-150">
              <Button onClick={formatJson} className="flex-1" data-id="element-151">
                Format
              </Button>
              <Button onClick={minifyJson} variant="outline" className="flex-1" data-id="element-152">
                Minify
              </Button>
            </div>
            {error && <p className="text-sm text-destructive" data-id="element-153">{error}</p>}
          </CardContent>
        </Card>

        <Card data-id="element-154">
          <CardHeader data-id="element-155">
            <div className="flex items-center justify-between" data-id="element-156">
              <div data-id="element-157">
                <CardTitle data-id="element-158">Output</CardTitle>
                <CardDescription data-id="element-159">Formatted JSON</CardDescription>
              </div>
              {outputJson && <Button onClick={copyToClipboard} variant="outline" size="sm" data-id="element-160">
                  {copied ? <Check className="w-4 h-4 mr-2" data-id="element-161" /> : <Copy className="w-4 h-4 mr-2" data-id="element-162" />}
                  {copied ? 'Copied!' : 'Copy'}
                </Button>}
            </div>
          </CardHeader>
          <CardContent data-id="element-163">
            {outputJson ? <div className="p-4 bg-muted rounded-lg font-mono text-sm overflow-auto max-h-[500px]" data-id="element-164">
                <pre data-id="element-165">{outputJson}</pre>
              </div> : <div className="text-center py-12 text-muted-foreground" data-id="element-166">
                Formatted JSON will appear here
              </div>}
          </CardContent>
        </Card>
      </div>
    </div>;
}